import { Box, Line, Text } from "@prismicio/editor-ui"

import { DocumentListBackButton } from "../app/components/DocumentListBackButton"
import { headerHeight, mainContentMaxWidth } from "../document/documentLayout"

export function APIExplorerPageHeader() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      height={headerHeight}
      border={{ bottom: true }}
      backgroundColor="grey2"
    >
      <Line color="purple" />
      <Box justifyContent="center" padding={16}>
        <Box width={mainContentMaxWidth} alignItems="center" gap={16}>
          <DocumentListBackButton />
          <Text variant="bold">API Explorer</Text>
        </Box>
      </Box>
    </Box>
  )
}
